import request from "@/router/request";

export const queryArrears = (queryValue,groupName) => {
    let queryType='0';
    let busiType="11";
    return request({
        url: 'api/WaterFeeBusiness/QueryArrears',
        method: "get",
        params: {
            queryType,
            busiType,
            queryValue,
            groupName
        },
        meta:{
            isToken:false
        }
    });
}
export const collectPayment = (data) => {
    return request({
        url: 'api/WaterFeeBusiness/CollectPayment',
        method: "post",
        data:data
    });
}
export const queryUserInfo = (queryValue,groupName) => {
    // let acctOrgNo='36750';
    let queryType="01";
    return request({
        url: 'api/WaterFeeBusiness/QueryUserInfo',
        method: "get",
        params: {
            queryType,
            queryValue,
            groupName
        },
        meta:{
            isToken:false
        }
    });
}
export const QueryPaymentRecords = (queryValue) => {
    let acctOrgNo='36750';
    let queryType="01";
    return request({
        url: 'api/WaterFeeBusiness/QueryPaymentRecordsList',
        method: "get",
        params: {
            acctOrgNo,
            queryType,
            queryValue
        },
        meta:{
            isToken:false
        }
    });
}